import { useCallback, useState } from 'react'
import { localStorageKeys } from '@sketch/constants'
import * as localStorage from '@sketch/utils/src/localStorage/localStorage'

type InspectorSectionOpenStateByKey = Record<string, boolean>

function readSectionOpenState(sectionIdentifier: string): boolean {
  const stored =
    localStorage.getParsedItem<InspectorSectionOpenStateByKey>(
      localStorageKeys.inspectorSectionOpenState
    ) ?? {}
  return stored[sectionIdentifier] ?? true
}

function writeSectionOpenState(
  sectionIdentifier: string,
  isOpen: boolean
): void {
  const stored =
    localStorage.getParsedItem<InspectorSectionOpenStateByKey>(
      localStorageKeys.inspectorSectionOpenState
    ) ?? {}

  localStorage.setStringifiedItem(localStorageKeys.inspectorSectionOpenState, {
    ...stored,
    [sectionIdentifier]: isOpen,
  })
}

/**
 * Persists the open/closed state of an inspector section in localStorage.
 * Defaults to open (`true`) if no stored value exists.
 */
export function useInspectorSectionOpenState(
  sectionIdentifier: string
): [boolean, (isOpen: boolean) => void] {
  const [isOpen, setIsOpenState] = useState(() =>
    readSectionOpenState(sectionIdentifier)
  )

  const setIsOpen = useCallback(
    (value: boolean) => {
      setIsOpenState(value)
      writeSectionOpenState(sectionIdentifier, value)
    },
    [sectionIdentifier]
  )

  return [isOpen, setIsOpen]
}
